/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { lazy } from "react";
import { Loadable } from "components/Loadable";

// const ModellingEntity = Loadable(lazy(() => import("sections/modelling/email-templates/index.jsx")));
// const ModellingModel = Loadable(lazy(() => import("sections/modelling/model-schema/index.jsx")));
// const ModellingEntity = Loadable(lazy(() => import("sections/modelling/email-templates/index.jsx")));
// const ModelSection = Loadable(lazy(() => import("sections/models/development/index")));

// const Modelling = Loadable(lazy(() => import("sections/modelling/modelling.jsx")));
const SchemaModelOverview = Loadable(lazy(() => import("sections/modelling/model/schema-list/index.jsx")));
const ModellingModel = Loadable(lazy(() => import("sections/modelling/model/schema-list/index.jsx")));
const ModellingEntity = Loadable(lazy(() => import("sections/modelling/entity/schema-list/index.jsx")));
const ModelSchemaList = Loadable(lazy(() => import("sections/modelling/model/schema-list/schema-list")));
const ModelSchemaDetail = Loadable(lazy(() => import("sections/modelling/model/schema-list/schema-detail")));
const ModelSchemaEdit = Loadable(lazy(() => import("sections/modelling/model/schema-list/schema-edit")));
const EntitySchemaList = Loadable(lazy(() => import("sections/modelling/entity/schema-list/schema-list")));
const EntitySchemaDetail = Loadable(lazy(() => import("sections/modelling/entity/schema-list/schema-detail")));
const EntitySchemaEdit = Loadable(lazy(() => import("sections/modelling/entity/schema-list/schema-edit")));

const modellingRoutes = [
    {
        path: "/modelling",
        element: <SchemaModelOverview />,
    },
    {
        path: "/modelling/model",
        element: <ModellingModel />,
    },
    {
        path: "/modelling/model/list",
        element: <ModelSchemaList />,
    },
    {
        path: "/modelling/model/display/:type",
        element: <ModelSchemaDetail />,
    },
    {
        path: "/modelling/model/edit/:type",
        element: <ModelSchemaEdit />,
    },
    {
        path: "/modelling/entity",
        element: <ModellingEntity />,
    },
    {
        path: "/modelling/entity/list",
        element: <EntitySchemaList />,
    },
    {
        path: "/modelling/entity/view/:type",
        element: <EntitySchemaDetail />,
    },
    {
        path: "/modelling/entity/edit",
        element: <EntitySchemaEdit />,
    },
    {
        path: "/modelling/entity/edit/:type",
        element: <EntitySchemaEdit />,
    },
];
export { modellingRoutes };
